var CARD_ICON_VARIANT;
(function (CARD_ICON_VARIANT) {
    CARD_ICON_VARIANT["ADD"] = "add";
    CARD_ICON_VARIANT["DEFAULT"] = "default";
    CARD_ICON_VARIANT["LOCK"] = "lock";
})(CARD_ICON_VARIANT || (CARD_ICON_VARIANT = {}));
var CARD_ICON_COLOR;
(function (CARD_ICON_COLOR) {
    CARD_ICON_COLOR["YELLOW"] = "yellow";
    CARD_ICON_COLOR["BLACK"] = "black";
    CARD_ICON_COLOR["CUSTOM"] = "custom";
})(CARD_ICON_COLOR || (CARD_ICON_COLOR = {}));

var CARD_BRAND;
(function (CARD_BRAND) {
    CARD_BRAND["MASTERCARD"] = "mastercard";
    CARD_BRAND["VISA"] = "visa";
    CARD_BRAND["DINERS"] = "diners";
    CARD_BRAND["MASTERCARD_BLACK"] = "mastercard_black";
    CARD_BRAND["VISA_BLACK"] = "visa_black";
    CARD_BRAND["DINERS_BLACK"] = "diners_black";
})(CARD_BRAND || (CARD_BRAND = {}));

export { CARD_BRAND as C, CARD_ICON_COLOR as a, CARD_ICON_VARIANT as b };
